import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer.js';
import { FaSearch } from "react-icons/fa";
import axios from 'axios';
import config from '../constants/config';
import parse from 'html-react-parser';

import '../styles/News.css';
import '../styles/Responsive.css';
import { FaArrowRight } from 'react-icons/fa';

export default function News() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [articles, setArticles] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  // Generate slug from title
  const createSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  };

  // Strip HTML tags from content
  const stripHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  };

  // Format date function
  const formatDate = (timestamp) => {
    const date = new Date(timestamp * 1000); // Convert Unix timestamp to milliseconds
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  // Fetch publications from API
  const fetchPublications = () => {
    setLoading(true);

    axios.post(
      `${config.api.url}publications/fetch`,
      {},
      {
        crossdomain: true,
        headers: {
          'api': config.api.key
        }
      }
    )
    .then((response) => {
      const { success, data } = response.data;
      if (success && data) {
        // Filter only active publications
        const activePublications = data.filter(pub => pub.active === "1");
        setArticles(activePublications);
      } else {
        console.error("Error fetching publications:", response.data.response);
      }
      setLoading(false);
    })
    .catch((error) => {
      console.error('Request error:', error);
      setLoading(false);
    });
  };

  // Fetch publications on component mount
  useEffect(() => {
    fetchPublications();
  }, []);

  // Filter articles based on search term
  const filteredArticles = searchTerm
    ? articles.filter(article => 
        article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        article.content.toLowerCase().includes(searchTerm.toLowerCase()) ||
        article.category.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : articles;

  return (
    <div className="News">
      <div className="NewsHeader">
        <div className="NewsHeaderContent">
          <div className="NewsHeaderContentTitle">News</div>
          <div className="NewsHeaderContentSubtitle">Stay up to date with the latest news from CANTO</div>
        </div>
      </div>

      <div className="NewsContent">
        <div className="NewsContentHeader">
          <div className="NewsContentHeaderTitle">Latest News/Press Releases</div>
          <div className="NewsContentHeaderSearch">
            <FaSearch className="NewsContentHeaderSearchIcon" />
            <input
              type="text"
              placeholder="Search news..."
              className="NewsContentHeaderSearchInput"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="NewsContentItems">
          {loading ? (
            <div className="loading">Loading publications...</div>
          ) : filteredArticles.length > 0 ? (
            filteredArticles.map((item, index) => (
              <div 
                className="NewsItem" 
                key={item.id || index}
                onClick={() => navigate(`/article/${createSlug(item.title)}`)}
              >
                <div className="NewsItemImage" style={{ backgroundImage: `url(${item.image})` }} />
                <div className="NewsItemContent">
                  <div className="NewsItemContentCategory">{item.category}</div>
                  <div className="NewsItemContentTitle">{item.title}</div>
                  <div className="NewsItemContentDate">{formatDate(item.timestamp)}</div>
                  <div className="NewsItemContentText">{stripHtml(item.content)}</div>
                  <div className="NewsItemContentReadMore">
                    Read More <FaArrowRight />
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-articles">No publications available.</div>
          )}
        </div>
      </div>

    </div>
  );
}
